/*----------------------
     MAIN PRODUCT
---------------------- */

swiperProductGallery = {
    init: function () {
        var swiper = new Swiper(".swiper--product", {
            slidesPerView: "auto",
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}

$(function () {
    swiperProductGallery.init();
});
